module.exports = __webpack_public_path__ + "82a689d82d87fd83079cea4921a45e3a.svg";